import BillzTypography from 'components/BillzTypographies/BillzTypography';
import * as Styled from './DataGridHeader.styles';
import PropTypes from 'prop-types';
import BillzTypographyGridHeader from 'components/BillzTypographies/BillzTypographyGridHeader';

export const DataGridHeader = ({ value }) => {
    return (
      <Styled.Wrapper>
          <BillzTypographyGridHeader>{value}</BillzTypographyGridHeader>
      </Styled.Wrapper>
    );
  };

  DataGridHeader.propTypes = {
    value: PropTypes.string.isRequired
  };
  